import { render, staticRenderFns } from "./StudentDropout.vue?vue&type=template&id=1394f1f8&scoped=true&"
import script from "./StudentDropout.vue?vue&type=script&lang=js&"
export * from "./StudentDropout.vue?vue&type=script&lang=js&"
import style0 from "./StudentDropout.vue?vue&type=style&index=0&id=1394f1f8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1394f1f8",
  null
  
)

export default component.exports